import { render, staticRenderFns } from "./TabsWithSlidingIndicator.vue?vue&type=template&id=337ae434&scoped=true&"
import script from "./TabsWithSlidingIndicator.vue?vue&type=script&lang=js&"
export * from "./TabsWithSlidingIndicator.vue?vue&type=script&lang=js&"
import style0 from "./TabsWithSlidingIndicator.vue?vue&type=style&index=0&id=337ae434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337ae434",
  null
  
)

export default component.exports